import React from 'react'

/* Payment Methods */
export const Giropay = React.lazy(() => import('./giropay'))
export const P24 = React.lazy(() => import('./p24'))
export const Ideal = React.lazy(() => import('./ideal'))
export const Eps = React.lazy(() => import('./eps'))
export const Mybank = React.lazy(() => import('./mybank'))
export const Bancontact = React.lazy(() => import('./bancontact'))
export const Blik = React.lazy(() => import('./blik'))
export const Trustly = React.lazy(() => import('./trustly'))
export const Verkkopankki = React.lazy(() => import('./verkkopankki'))
export const Payu = React.lazy(() => import('./payu'))
/* istanbul ignore next */
export const Boleto = React.lazy(() => import('./boleto'))
export const Oxxo = React.lazy(() => import('./oxxo'))
export const Multibanco = React.lazy(() => import('./multibanco'))
export const Alipay = React.lazy(() => import('./alipay'))
export const Wechatpay = React.lazy(() => import('./wechatpay'))
export const Satispay = React.lazy(() => import('./satispay'))
export const Paidy = React.lazy(() => import('./paidy'))
